package com.sweetlime.dungeonamigo

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import cafe.adriel.voyager.navigator.Navigator
import com.sweetlime.dungeonamigo.presentation.features.splash.SplashScreen
import com.sweetlime.dungeonamigo.presentation.ui.theme.BrandColors

@Composable
fun App() {
    Box(Modifier.fillMaxSize().background(BrandColors.Background)) {
        Navigator(SplashScreen())
    }
}
